class LoadMore extends HTMLElement {
    constructor() {
        super();

        this.handleClick = this.handleClick.bind(this);
        this.parentContainer = this.closest("[data-load-more-container]");
        this.targetContainer = this.parentContainer.querySelector("[data-load-more-target-container]");
        this.currentPage = this.dataset.currentPage;
        this.nextUrl = this.dataset.nextUrl;
        this.totalPages = this.dataset.totalPages;
    }

    connectedCallback() {
        this.addEventListener("click", this.handleClick);
    }

    disconnectedCallback() {
        this.removeEventListener("click", this.handleClick);
    }

    handleClick(event) {
        if (event.target.closest("[data-load-more-button]")) {
            event.target.classList.add("loading");
            event.target.disabled = true;

            const nextPage = +this.currentPage + 1;
            const url = this.nextUrl.replace(/page=[0-9]+/, 'page=' + nextPage);

            fetch(url)
                .then(response => response.text())
                .then((data) => {
                    const dataHtml = new DOMParser().parseFromString(data, "text/html");
                    const loadedContent = dataHtml.querySelector("[data-load-more-target-container]");

                    if (loadedContent) {
                        this.targetContainer.innerHTML += loadedContent.innerHTML;  
                        this.focusFirstLatestItem(loadedContent);                   
                    }
                })
                .catch((error) => {
                    console.error(error)
                })
                .finally(() => {
                    this.currentPage = +this.currentPage + 1;

                    if (+this.currentPage >= +this.totalPages) {
                        this.classList.add("hidden");
                    }

                    event.target.classList.remove("loading");
                    event.target.disabled = false;
                })
        }
    }

    focusFirstLatestItem(container) {
        const tempElementList = container.querySelectorAll("[data-focused-item-id]:not([tabindex='-1'])");
        const updatedElementList = this.targetContainer.querySelectorAll("[data-focused-item-id]:not([tabindex='-1'])");

        if (tempElementList && tempElementList.length > 0) {
            const firstElement = tempElementList[0];

            if (firstElement) {
                const focusedElement = [...updatedElementList].find(item => item.dataset.focusedItemId === firstElement.dataset.focusedItemId);
                
                if (focusedElement) {
                    focusedElement.focus();
                }
            }
        }
    }
}

if(!window.customElements.get("load-more")) {
    window.customElements.define("load-more", LoadMore);
}